import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedComponent } from './shared.component';
import { MenuComponent } from './menu/menu.component';
import { IonicModule } from '@ionic/angular';
import { FilterComponent } from './filter/filter.component';
import { WhyPurchaseAddonComponent } from './why-purchase-addon/why-purchase-addon.component';
import { FaqComponent } from './faq/faq.component';
import { SubscribeComponent } from './subscribe/subscribe.component';
import { VerificationComponent } from './verification/verification.component';
import { NgOtpInputModule } from 'ng-otp-input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ExpandableComponent } from './expandable/expandable.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { SuccessComponent } from './success/success.component';
import { GeneralNotificationComponent } from './general-notification/general-notification.component';
import { AccountListComponent } from './account-list/account-list.component';
import { VerificationLoginComponent } from './verification-login/verification-login.component';
import { ViewCmsContentComponent } from './view-cms-content/view-cms-content.component';
import { CountryListComponent } from './country-list/country-list.component';
import { CfmViewFormComponent } from './cfm-view-form/cfm-view-form.component';
import { SortComponent } from './sort/sort.component';
import { ValidityFormatComponent } from './validity-format/validity-format.component';
import { CfmModelComponent } from './cfm-view-form/cfm-model/cfm-model.component';
import { ListFilterPipe } from '../pipes/list-filter.pipe';
import { ErrorComponent } from './error/error.component';
import { environment } from 'src/environments/environment';
import { NgSelectModule } from '@ng-select/ng-select';
import { NavBarComponent } from './nav-bar/nav-bar.component';
import { NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { ViewDocumentsComponent } from './view-documents/view-documents.component';
import { UploadDocumentComponent } from './upload-document/upload-document.component';
import { CheckoutStatusComponent } from './checkout-status/checkout-status.component';
import { NetworkDetailsComponent } from './network-details/network-details.component';
import { LeavePageComponent } from './leave-page/leave-page.component';
import { RequestStatusWizardComponent } from './request-status-wizard/request-status-wizard.component';
import { RequestLetterAvailableComponent } from './request-letter-available/request-letter-available.component';
import { DndDirective } from '../directives/dnd.directive';
import { ConfirmationBoxComponent } from './confirmation-box/confirmation-box.component';
import { UploadPaymentDocumentComponent } from './upload-payment-document/upload-payment-document.component';
import { FollowUpModalComponent } from './follow-up-modal/follow-up-modal.component';
import { SuccessFollowUpComponent } from './success-follow-up/success-follow-up.component';
import { TermsAndConditionComponent } from './terms-and-condition/terms-and-condition.component';
import { LayoutsModule } from '../layouts/layouts.module';
@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    NgOtpInputModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    NgbDatepickerModule,
    LayoutsModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
  declarations: [
    SharedComponent,
    MenuComponent,
    FilterComponent,
    WhyPurchaseAddonComponent,
    FaqComponent,
    SubscribeComponent,
    VerificationComponent,
    ExpandableComponent,
    SuccessComponent,
    GeneralNotificationComponent,
    AccountListComponent,
    VerificationLoginComponent,
    ViewCmsContentComponent,
    CountryListComponent,
    CfmViewFormComponent,
    SortComponent,
    ValidityFormatComponent,
    CfmModelComponent,
    ListFilterPipe,
    ErrorComponent,
    NavBarComponent,
    ViewDocumentsComponent,
    UploadDocumentComponent,
    CheckoutStatusComponent,
    NetworkDetailsComponent,
    LeavePageComponent,
    RequestStatusWizardComponent,
    RequestLetterAvailableComponent,
    DndDirective,
    ConfirmationBoxComponent,
    UploadPaymentDocumentComponent,
    FollowUpModalComponent,
    SuccessFollowUpComponent,
    TermsAndConditionComponent
  ],
  entryComponents: [
    MenuComponent,
    FilterComponent,
    WhyPurchaseAddonComponent,
    FaqComponent,
    SubscribeComponent,
    VerificationComponent,
    ExpandableComponent,
    SuccessComponent,
    GeneralNotificationComponent,
    AccountListComponent,
    VerificationLoginComponent,
    ViewCmsContentComponent,
    CountryListComponent,
    CfmViewFormComponent,
    SortComponent,
    ValidityFormatComponent,
    CfmModelComponent,
    ErrorComponent,
    NavBarComponent,
    ViewDocumentsComponent,
    UploadDocumentComponent,
    CheckoutStatusComponent,
    NetworkDetailsComponent,
    LeavePageComponent, 
    RequestStatusWizardComponent,
    RequestLetterAvailableComponent,
    ConfirmationBoxComponent,
    UploadPaymentDocumentComponent
  ],
  exports: [
    MenuComponent,
    FilterComponent,
    WhyPurchaseAddonComponent,
    FaqComponent,
    SubscribeComponent,
    VerificationComponent,
    ExpandableComponent,
    SuccessComponent,
    GeneralNotificationComponent,
    AccountListComponent,
    VerificationLoginComponent,
    ViewCmsContentComponent,
    CountryListComponent,
    CfmViewFormComponent,
    SortComponent,
    ValidityFormatComponent,
    CfmModelComponent,
    ErrorComponent,
    NavBarComponent,
    ViewDocumentsComponent,
    UploadDocumentComponent,
    CheckoutStatusComponent,
    NetworkDetailsComponent,
    LeavePageComponent,
    RequestStatusWizardComponent,
    RequestLetterAvailableComponent,
    DndDirective,
    ConfirmationBoxComponent,
    UploadPaymentDocumentComponent
  ],
})
export class SharedModule { }
// required for AOT compilation
export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, environment.HOST + '/b2c/cqt-app/assets/i18n/', '.json');
}
